import { render, staticRenderFns } from "./UnderlyingPolicies.vue?vue&type=template&id=5762c9f6"
import script from "./UnderlyingPolicies.vue?vue&type=script&lang=js"
export * from "./UnderlyingPolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports